export default {
  tip: {
    danger: 'This operation is risk!',
    googleCode: 'Enter the Google verification code'
  },
  btns: {
    today: 'today',
    yesterday: 'previous day',
    tomorrow: ' next day',
    month: 'this month',
    lastMonth: 'last month'
  },
  label: {
    form: {
      submitTime: 'Submission time',
      merchatNo: 'Merchant account',
      agentNo: 'Third party',
      merchatOrderNo: 'trasaction code',
      systemOrderNo: 'System code',
      channelType: 'payment method',
      callbackStatus: 'callback status',
      orderStatus: 'transaction status',
      description: ' content',
      remark: 'remark', // comment 备注
      patchStatus: 'replenished status', // comment 备注
      amountStart: 'Starting and ending amount'
    },
    table: {
      // agentNo: "Third party",
      merchatNo: 'Merchant account',
      systemOrderNo: 'OrderNo',
      merchatOrderNo: 'transaction code', // comment 商户订单号 merchant transaction code
      channelType: 'payment method', // comment 通道类型  merchant type

      channelCode: 'Channel Code',
      submitAmount: 'submit Amount',
      paymentAmount: 'Actual payment',
      handlingFee: 'fee', // comment 手续费 fee
      callbackAmount: 'actual received amount',
      description: 'content', // comment 描述 description
      // callbackTime: "callback time",
      payoutTime: 'payout time', // comment 订单支付时间
      remark: 'remark', // comment 备注
      callbackStatus: 'callback status',
      orderStatus: 'transaction status',
      dispensing: 'Dispensing',
      patchType: 'replenished type', // comment 备注
      patchStatus: 'replenished status', // comment 备注
      patcher: 'processing person', // comment 备注
      nowAmount: 'actual received'
    },
    list: {
      totalNumber: 'transaction approved',
      totalSuccessMoney: 'success amount',
      totalMoney: 'actual received amount',
      totalfee: 'fees',
      makeupAmount: 'Total amount of supplementary orders',
      inTranAmountTotal: 'Total amount of payments received',
      inTranTotal: 'Number of payments received',
      outTranAmountTotal: 'Total amount of withdrawals',
      outTranTotal: 'Number of withdrawals'
    }
  },
  rules: {
    submitTime: 'order time cannot be empty'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/orders.js